export default __webpack_public_path__ + "static/media/flo-energy-logo.b8dcf13e.png";